"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = __importStar(require("react"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const useTopicPilotQueryString_1 = __importDefault(require("../../hooks/useTopicPilotQueryString"));
const ResellerFiles = () => {
    const [iFrameInitiallyLoading, setIFrameInitiallyLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        document.title = (0, translation_1.t)('reseller_subpage_title', { title: (0, translation_1.t)('reseller.files.page_title') });
    }, []);
    const query = (0, useTopicPilotQueryString_1.default)();
    return (react_1.default.createElement("div", { className: "w-100 flex-grow-1 d-flex position-relative" },
        react_1.default.createElement("iframe", { className: "w-100 flex-grow-1 border-0", src: `${__APP__.TOPIC_PILOT_URL}${query}`, onLoad: () => setIFrameInitiallyLoading(false) }),
        iFrameInitiallyLoading ? react_1.default.createElement(LoadingSpinner_1.default, { center: true }) : null));
};
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scopes: [AuthorizationScopes_1.default.RESELLER_READ, AuthorizationScopes_1.default.RESELLER_DOCUMENTS_READ] })(ResellerFiles));
